import React, { Component } from 'react';
import { Row, Col } from '@deere/ux.uxframe-react';
import { Link } from 'react-router-dom';

class SignOut extends Component {

    render() {
        return (
            <div className="container-fluid text-center mb-2">
                <Row className="mb-2">
                    <Col>
                        Sign Out Successfully
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Link to="/">
                            <button className="btn btn-outline-primary" type="button">
                                Click here to login again!!
                            </button>
                        </Link>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default SignOut;
